import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Note from '../../note';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { isJson } from '../../utils/utils';
import { fieldSubscriberDetailsDevices } from '../../utils/constant';

const FieldSelect = ({ data }) => {
  const [tooltipIsShown, setTooltipIsShown] = useState(false);
  const {
    ref,
    name,
    label,
    value,
    required,
    options,
    onChange,
    note,
    tooltip,
    disabled,
    readonly,
    noteAppearsBelowField,
    isShowNoteBackground
  } = data;
  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )
    );
  };

  const localizedStrings = useLocalizedStringsContext();
  const { quoteForm } = localizedStrings;

  const getSelectedDevice = (itemValue) => {
    const itemObject = isJson(itemValue) ? JSON.parse(itemValue) : itemValue;
    const valueObject = isJson(value) ? JSON.parse(value) : value;
    return itemObject.device_name && itemObject.device_name === valueObject.device_name && valueObject.device_name;
  };

  return (
    <div
      style={{
        marginTop: '15px',
        width: '100%',
        position: 'relative'
      }}
    >
      <span className="frg-body-font-14px">
        {label}
        {required && `*`}
      </span>
      {!noteAppearsBelowField && renderNotes()}
      <div
        onMouseEnter={() => setTooltipIsShown(true)}
        onMouseLeave={() => setTooltipIsShown(false)}
        className="frg-select-container color-light"
        style={{ position: 'relative', width: '100%', height: '50px' }}
      >
        <select
          ref={ref}
          id={name}
          name={name}
          onChange={onChange}
          disabled={disabled || readonly}
        >
          <option key="option" value="" />
          {options &&
            options.map(item => {
              if (!item.fields) return null;

              const {
                fields: {
                  value: itemValue,
                  label: itemLabel,
                  price,
                  monthlyPayment,
                  showPricesInLabel
                }
              } = item;
              const key = `${name}option${itemValue}`;
              let optionLabel = itemLabel;
              if (showPricesInLabel) {
                if (price)
                  optionLabel = `${optionLabel}: ${quoteForm.upfront}: $${price}`;
                if (monthlyPayment)
                  optionLabel = `${optionLabel}${price ? ', ' : ': '} ${quoteForm.monthly
                    }: $${monthlyPayment}`;
              }

              return (
                <option
                  key={key}
                  value={itemValue}
                  selected={name === fieldSubscriberDetailsDevices ? getSelectedDevice(itemValue) : value === itemValue}
                >
                  {optionLabel}
                </option>
              );
            })}
        </select>
      </div>
      {noteAppearsBelowField && renderNotes()}
      {tooltipIsShown && <div>{tooltip}</div>}
    </div>
  );
};

FieldSelect.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    required: PropTypes.bool,
    readonly: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          value: PropTypes.string.isRequired
        })
      })
    ),
    onChange: PropTypes.func.isRequired,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    noteAppearsBelowField: PropTypes.bool
  }).isRequired
};

export default FieldSelect;
